import { toastr } from 'react-redux-toastr';

import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';
import { hideUnassignFormModal } from './unassignFormModal';
import { getForms } from './getForms';

export const UNASSIGN_TO_USER_REQUEST = 'UNASSIGN_TO_USER_REQUEST';
export const UNASSIGN_TO_USER_SUCCESS = 'UNASSIGN_TO_USER_SUCCESS';
export const UNASSIGN_TO_USER_ERROR = 'UNASSIGN_TO_USER_ERROR';

function requestUnassignToUser() {
  return {
    type: UNASSIGN_TO_USER_REQUEST,
  };
}

function receiveUnassignToUser() {
  return {
    type: UNASSIGN_TO_USER_SUCCESS
  };
}

function rejectUnassignToUser() {
  return {
    type: UNASSIGN_TO_USER_ERROR
  };
}

export function unassignFormsToUser(formIdlist, user, currentPageNumber, currentPageSize) {
  return (dispatch) => {
    dispatch(requestUnassignToUser());

    const promise = () => ApiService
      .assignFormToUser(formIdlist, user.id)
      .then((response) => {
        dispatch(hideUnassignFormModal());
        dispatch(receiveUnassignToUser(response.data));
        toastr.success('', 'The user has been successfully unassigned');
        return dispatch(getForms(currentPageNumber, currentPageSize));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectUnassignToUser, true));
        }
      });
    return promise();
  };
}

export function unassignFormsToUserWithCallback(forms, callback) {
  return (dispatch) => {
    dispatch(requestUnassignToUser());

    const promise = () => ApiService
      .unassignFormToUser(forms)
      .then((response) => {
        dispatch(hideUnassignFormModal());
        dispatch(receiveUnassignToUser(response.data));
        toastr.success('', 'The user has been successfully unassigned');
        callback();
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectUnassignToUser, true));
        }
      });
    return promise();
  };
}
